import type { ReactNode } from "react";
import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import NoPermission from "@/pages/NoPermission";
import Home from "@/pages/home/page";
import ProductDetail from "@/pages/product/page";
import Cart from "@/pages/cart/page";
import Orders from "@/pages/orders/page";
import OrderDetail from "@/pages/order/page";
import Login from "@/pages/login/page";
import ProxyOrder from "@/pages/proxy-order/page";
import Reports from "@/pages/reports/page";
import FrequentPurchase from "@/pages/frequent-purchase/page";
import WorkApproval from "@/pages/work-approval/page";
import AfterSales from "@/pages/after-sales/page";
import AuthGuard, { GuestGuard, DivideGuard, LimitQuotaGuard } from "./AuthGuard";
import PurchasePlan from "@/pages/purchase-plan/page";
import PurchasePlanDetail from "@/pages/purchase-plan/detail";

function withAuth(element: ReactNode) {
  return <AuthGuard>{element}</AuthGuard>;
}

function withDivideAuth(element: ReactNode) {
  return (
    <AuthGuard>
      <DivideGuard>{element}</DivideGuard>
    </AuthGuard>
  );
}

function withLimitQuotaAuth(element: ReactNode) {
  return (
    <AuthGuard>
      <LimitQuotaGuard>{element}</LimitQuotaGuard>
    </AuthGuard>
  );
}

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Navigate to="/login" replace />,
  },
  {
    path: "/login",
    element: (
      <GuestGuard>
        <Login />
      </GuestGuard>
    ),
  },
  {
    path: "/goods",
    element: withAuth(<Home />),
  },
  {
    path: "/product/:id",
    element: withAuth(<ProductDetail />),
  },
  {
    path: "/cart",
    element: withAuth(<Cart />),
  },
  {
    path: "/orders",
    element: withAuth(<Orders />),
  },
  {
    path: "/order/:id",
    element: withAuth(<OrderDetail />),
  },
  {
    path: "/proxy-order",
    element: withDivideAuth(<ProxyOrder />),
  },
  {
    path: "/reports",
    element: withAuth(<Reports />),
  },
  {
    path: "/frequent-purchase",
    element: withAuth(<FrequentPurchase />),
  },
  {
    path: "/work-approval",
    element: withAuth(<WorkApproval />),
  },
  {
    path: "/purchase-plan",
    element: withLimitQuotaAuth(<PurchasePlan />),
  },
  {
    path: "/purchase-plan/:id",
    element: withLimitQuotaAuth(<PurchasePlanDetail />),
  },
  {
    path: "/after-sales",
    element: withAuth(<AfterSales />),
  },
  {
    path: "/403",
    element: withAuth(<NoPermission />),
  },
  {
    path: "/404",
    element: <NotFound />,
  },
];

export default routes;
